import { useState } from 'react';
import { getFriendlyTime } from '@zorba-shared/core/Services/textService';
import { MdVerifiedUser } from '@react-icons/all-files/md/MdVerifiedUser';
import { Badge, Space } from 'antd';

import { USER_KIND_TITLES } from '../../../../constants/permission';
import { ZorbaButton } from '../../../../components/forms';
import { showErrorToast } from '../../../../services/notificationsService';
import { postRequest } from '../../../../services/requestService';

import './index.scss';

const DEFAULT_USER_IMAGE =
  'https://app.getzorba.com/img/auth/default-user-img.jpg';

export default (props) => {
  const { selectedBuyer } = props;
  const [isLoading, setIsLoading] = useState(false);
  const isVerified =
    !!selectedBuyer.defaultOrganization?.verification?.verified;

  const handleMimicUser = async () => {
    setIsLoading(true);
    try {
      await postRequest('/backoffice/user/mimic-user', {
        userId: selectedBuyer._id,
      });
      window.open('https://buy.getzorba.com', '_blank');
    } catch (error) {
      showErrorToast(error.response?.data?.error || 'Failed to mimic user');
    }
    setIsLoading(false);
  };

  const handleMimicUserPartnersApp = async () => {
    setIsLoading(true);
    try {
      await postRequest('/backoffice/user/mimic-user', {
        userId: selectedBuyer._id,
      });
      window.open('https://partners.getzorba.com', '_blank');
    } catch (error) {
      showErrorToast(error.response?.data?.error || 'Failed to mimic user');
    }
    setIsLoading(false);
  };

  return (
    <div className="top-section-info">
      <div className="left">
        <div className="user-img">
          <img
            src={selectedBuyer.picture || DEFAULT_USER_IMAGE}
            alt={selectedBuyer?.name}
          />
          {isVerified && (
            <div className="verified-icon">
              <MdVerifiedUser />
            </div>
          )}
        </div>
        <div className="names">
          <div className="full-name">
            {selectedBuyer.name}{' '}
            <Space
              size={[8, 8]}
              wrap
              className="user-permissions"
              align="center"
            >
              {isVerified && <Badge count="Verified" color="#00cb6f" />}

              {selectedBuyer.kind?.length > 0 &&
                selectedBuyer.kind.map((kind) => (
                  <Badge
                    key={kind}
                    count={USER_KIND_TITLES[kind]}
                    color="#ec8337"
                  />
                ))}
            </Space>
          </div>
          <div className="company">
            Company: {selectedBuyer.defaultOrganization?.name} (
            {selectedBuyer.defaultOrganization?.friendlyUrl})
          </div>
          <div className="company">
            Company signed up at:{` `}{' '}
            {getFriendlyTime(selectedBuyer.defaultOrganization?.createdAt)}
          </div>
          <div className="member-since">
            Member since:{' '}
            {getFriendlyTime(
              selectedBuyer.createdAt || selectedBuyer.dateCreated,
            )}
          </div>
          <div className="stats__item">
            <div className="stats__item--label">Last login:</div>
            <div className="stats__item--value">
              {getFriendlyTime(selectedBuyer.lastLogin)}
            </div>
          </div>
          <div className="buttons-container">
            <ZorbaButton
              fullWidth={false}
              onClick={handleMimicUser}
              disabled={isLoading}
              isLoading={isLoading}
            >
              Mimic Buyer Dashboard
            </ZorbaButton>
            <ZorbaButton
              fullWidth={false}
              onClick={handleMimicUserPartnersApp}
              disabled={isLoading}
              isLoading={isLoading}
            >
              Mimic Seller Dashboard
            </ZorbaButton>
          </div>
        </div>
      </div>
    </div>
  );
};
